// extracted by mini-css-extract-plugin
module.exports = {"panel-header":"AssessmentEditorComponent_panel-header__2jBez","editor":"AssessmentEditorComponent_editor__2G8zq","preview":"AssessmentEditorComponent_preview__2Oxes"};